import PinPad from './PinPad';
export default PinPad;
